import { DateTime } from 'luxon';
import { TranslationService } from '../../../../../../services/translation.service';
import { DateHelper } from '../../../../../../helpers/date.helper';
import { createWhenString } from '../../../../../Shared/TripLegSelector/components/helpers/summary-helpers';

function Summary({
  id,
  departureStation,
  arrivalStation,
  departureTime,
  arrivalTime,
  onEditButtonClick,
}: {
  id: string;
  departureStation: string;
  arrivalStation: string;
  departureTime: DateTime;
  arrivalTime: DateTime;
  onEditButtonClick?: (() => void) | undefined;
}) {
  return (
    <div className="trip-leg-selector-summary p-2 rounded border">
      <table className="table table-borderless table-sm">
        <caption className="visually-hidden">{TranslationService.get('customerserviceforms.triplegselectorsummarycaption')}</caption>
        <tbody>
          <tr>
            <th scope="row">{TranslationService.get('common.from')}:</th>
            <td className="w-100">{departureStation}</td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.to')}:</th>
            <td>{arrivalStation}</td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.when')}:</th>
            <td>
              <span className="text-preserve-spaces">{createWhenString(departureTime.toString(), arrivalTime.toString())}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.traveltime')}:</th>
            <td>{DateHelper.formatAsHoursAndMinutes(DateHelper.getDurationFromDateStrings(departureTime.toString(), arrivalTime.toString()))}</td>
          </tr>
        </tbody>
      </table>
      <div className="text-end">
        <button className="btn--as-link" aria-controls={`${id}-form`} onClick={onEditButtonClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default Summary;
